"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var filter_1 = tslib_1.__importDefault(require("lodash/fp/filter"));
var reduce_1 = tslib_1.__importDefault(require("lodash/fp/reduce"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/fp/cloneDeep"));
var debounce_1 = tslib_1.__importDefault(require("lodash/debounce"));
var findItems = debounce_1.default(function (searchText, array, setFilteredItemTypes) {
    var arrayCopy = cloneDeep_1.default(array);
    var searchTextLowerCase = searchText.toLowerCase();
    var res = reduce_1.default(function (acc, initialArrays) {
        var aFilteredSubTypes = filter_1.default(function (initialSubTypes) {
            if (initialSubTypes.SubTypes) {
                var bFilteredSubTypes = filter_1.default(function (secondarySubTypes) {
                    return secondarySubTypes.Name.toLowerCase().indexOf(searchTextLowerCase) !== -1;
                }, initialSubTypes.SubTypes);
                if (bFilteredSubTypes.length) {
                    initialSubTypes.SubTypes = bFilteredSubTypes;
                    return true;
                }
                return false;
            }
            return (initialSubTypes.Name.toLowerCase().indexOf(searchTextLowerCase) !==
                -1);
        }, initialArrays === null || initialArrays === void 0 ? void 0 : initialArrays.SubTypes);
        if (aFilteredSubTypes.length && initialArrays) {
            initialArrays.SubTypes = aFilteredSubTypes;
            acc === null || acc === void 0 ? void 0 : acc.push(initialArrays);
        }
        return acc;
    }, [], arrayCopy);
    setFilteredItemTypes(res);
    return res;
}, 80);
exports.default = findItems;
